/** @jsx jsx */
import { jsx, Box } from "theme-ui"
import { Logo } from "../Logo"
import { SearchInput } from "../SearchInput"
import * as styles from "./styles"
import React from "react"

interface HeaderProps {
  onSearchChange: (value: string) => void
}

export const Header: React.FC<HeaderProps> = ({ onSearchChange }) => {
  return (
    <Box as="header" sx={styles.root}>
      <Logo alt="Allma logo" />
      <SearchInput sx={styles.search} onSearchChange={onSearchChange} />
    </Box>
  )
}
